import { useCallback } from "react";
import { validatePayrollMappingForm } from "../../HelperFunctions/PayrollEntryHelpers";

export const usePayrollActions = ({
  values,
  formValues,
  isDropdownSelected,
  showErrorSnackbar,
  setFieldError,
  setFieldTouched
}) => {

  const getCleanedValues = useCallback((currentValues) => {
    return {
      ...currentValues,
      wage: (currentValues.wage || []).filter( w => w.mappedTo && w.coa ),
      addAndDeductions: (currentValues.addAndDeductions || []).filter( a => a.addDeduction && a.mappedTo && a.coa ),
      eeAndErTaxes: (currentValues.eeAndErTaxes || []).filter( t => t.taxType && t.mappedTo && t.coa )
    };
  }, []);

  const validateForm = useCallback(() => {
    return validatePayrollMappingForm({
      isDropdownSelected,
      formValues,
      values,
      setFieldError,
      setFieldTouched,
      showErrorSnackbar
    });
  }, [ isDropdownSelected, formValues, values, setFieldError, setFieldTouched, showErrorSnackbar ]);

  return {
    getCleanedValues,
    validateForm
  };
};